export default ".autocomplete__items__item:last-child{border-bottom:none}";